import React from 'react';
import Hero from './Hero/RoadsideHero';
import NeedServicing from './NeedServicing/RoadsideNeedServicing';
import RoadsideBlock from './RoadsideBlock/RoadsideBlock';
import ContactRoadside from './ContactRoadside/RoadsideContactRoadside';

const RoadsideAssistance = ({
  heroData,
  needServicingData,
  roadsideBlockData,
  contactRoadsideData,
}) => {
  return (
    <>
      <Hero data={heroData} />
      <NeedServicing data={needServicingData} />
      <RoadsideBlock data={roadsideBlockData} />
      <ContactRoadside data={contactRoadsideData} />
    </>
  );
};

export default RoadsideAssistance;
